import { useEffect, useState } from "react";
import WordmarkLogo from "@/components/wynn/WordmarkLogo";

const LOGO =
  "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/xl70jip2_WYNN%20%282%29.png";

const LINKS = [
  { label: "The practice", href: "#studio" },
  { label: "Inside", href: "#features" },
  { label: "The maker", href: "#founder" },
  { label: "Questions", href: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="wynn-nav"
      className={`sticky top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#070608]/80 backdrop-blur-xl border-b border-[#F4F1EC]/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src={LOGO} alt="" aria-hidden className="h-9 w-auto select-none" draggable="false" />
          <WordmarkLogo height={20} />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              onClick={() => scrollTo(l.href)}
              className="font-body text-[12px] uppercase tracking-[0.18em] text-[#F4F1EC]/60 hover:text-[#FFB7C6] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            data-testid="nav-open-app"
            href="/app"
            className="hidden sm:inline-flex font-body text-[12px] uppercase tracking-[0.18em] h-10 px-4 items-center text-[#F4F1EC]/70 hover:text-[#FFB7C6] transition-colors"
          >
            Open app
          </a>
          <button
            data-testid="nav-cta"
            onClick={() => scrollTo("#join")}
            className="font-body text-[12px] uppercase tracking-[0.18em] h-10 px-5 inline-flex items-center bg-[#F4F1EC] text-[#070608] hover:bg-white transition-colors"
          >
            Join
          </button>
        </div>
      </div>
    </header>
  );
}
